class Steps { 
  constructor() { 
    this.wizardsteps = []
  } 
  add(label,current,disabled,completed,sequence) { 
    this.wizardsteps.push({
			label,
			current,
			disabled,
			completed,
			sequence
		})
	}
	get steps() {
		return this.wizardsteps
	}
} 

export default Steps;


// WEBPACK FOOTER //
// ./src/components/common/wizard/logic/steps.js